<template>
  <table class="policy-listing">
    <tr
      class="policy-listing__row"
      v-for="policy in sortedPolicies"
      :key="policy.id"
    >
      <td class="policy-listing__score">
        <div class="score">
          <div
            class="score-radius"
            :class="{
              'in-force': policy.status === 'In force',
              announced: policy.status === 'Announced',
              achieved: policy.status === 'Achieved',
              ended: policy.status === 'Ended',
            }"
          />
        </div>
      </td>
      <td class="policy-listing__date">
        {{ policy.year }}
      </td>
      <td class="policy-listing__title">
        <a
          :href="`${baseURL}/${getPolicyLink(policy)}`"
          target="_blank"
          title="View policy details"
          >{{ policy.title }}</a
        >
      </td>
      <td class="policy-listing__category">
        {{
          policy.category
            ? policy.category
                .filter((cat) => categories.includes(cat))
                .join(", ")
            : ""
        }}
      </td>
      <td class="policy-listing__jurisdiction">
        {{ policy.jurisdiction }}
      </td>
    </tr>
  </table>
</template>

<script>
export default {
  props: {
    policies: {
      type: Array,
      required: true,
    },
    categories: {
      type: Array,
      default: () => [],
    },
    test: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    baseURL() {
      const { test } = this;
      return `https://${test ? "test" : "www"}.iea.org/policies`;
    },
    sortedPolicies() {
      return this.policies.toSorted((a, b) => b.year - a.year);
    },
  },
  methods: {
    getPolicyLink(policy) {
      return `${policy.policyID}-${policy.title}`
        .toLowerCase()
        .replace(/_/g, "-")
        .replace(/@/g, "at")
        .match(
          /[a-zA-ZáàâäãåçéèêëíìîïñóòôöõúùûüýÿæœÁÀÂÄÃÅÇÉÈÊËÍÌÎÏÑÓÒÔÖÕÚÙÛÜÝŸÆŒ0-9\s-]+/g
        )
        .join("")
        .replace(/\s+/g, "-")
        .replace(/-+/g, "-");
    },
  },
};
</script>

<style scoped>
table.policy-listing {
  border-top: 1px solid #f2f2f2;
  margin: 24px 0px;
  width: 100%;
}
table.policy-listing tr.policy-listing__row {
}
table.policy-listing tr:nth-child(even) {
  background: #f2f2f2;
}
table.policy-listing td {
  padding: 6px 8px;
  height: 2.25rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  vertical-align: middle;
  color: #6f6f6f;
}
table.policy-listing td.policy-listing__title {
  color: #000;
}
table.policy-listing td.policy-listing__title a:hover {
  box-shadow: inset 0 0 0 0 #fff, inset 0 -1px 0 0 rgba(0, 0, 0, 0.4) !important;
}
table.policy-listing td.policy-listing__score {
  width: 48px;
}
table.policy-listing td.policy-listing__date {
  width: 80px;
}
table.policy-listing td.policy-listing__jurisdiction {
  width: 120px;
}
table.policy-listing td.policy-listing__category {
  width: 30%;
  text-align: left;
}
</style>